import css from '@/sui/less/modules.less'
import units from '@/sui/data/units'
import go from '@/gojs/go'

const moduleTypes = {
  surveillance: 0,
  observation: 1,
  research: 2,
  results: 3,
  causeAnalysis: 4
}

function obsManagmentFormatter (type) {
  switch (type) {
    case 1: return 'P1'
    case 2: return 'P2'
    case 3: return 'P3'
    case 4: return 'B1'
    case 5: return 'B2'
    case 6: return 'P4'
    case 7: return 'R1'
    case 8: return 'P5'
  }
  return ''
}

function buildImports () {
  const shMods = [
    'bactADI', 'reaBactADI', 'reaInfADI', 'neoInfADI', 'diaInfADI', 'expADI',
    'observa4', 'spy4', 'badicause'
  ]

  const result = {}
  function defaultOrUndefined (m) {
    return m != null ? m.default : undefined
  }

  for (let i = 0; i !== shMods.length; ++i) {
    const m = shMods[i]
    const fl = require(`@/sui/data/flatten/${m}`)
    const cv = require(`@/sui/data/sheets/convert/${m}`)
    const ed = require(`@/sui/data/sheets/edit/${m}`)

    result[m] = {
      flatten: defaultOrUndefined(fl),
      convert: defaultOrUndefined(cv),
      edit: defaultOrUndefined(ed)
    }
  }
  return result
}

function buildSheets (src, y) {
  return {
    flatten: src.flatten[y],
    convert: src.convert[y],
    edit: src.edit[y]
  }
}

const resultsModule = {
  label: 'Résultats',
  color: css.results,
  nosheets: true,
  type: moduleTypes.results
}

const imports = buildImports()

const moduleUnits = (function () {
  const result = {}
  for (let y in units) {
    const neo = []
    const dia = []
    const rea = []
    const uy = units[y]

    for (let i = 0; i !== uy.infADI.length; ++i) {
      const u = uy.infADI[i]
      if (uy.isNeo(u.index)) {
        neo.push(u)
      } else if (uy.isDia(u.index)) {
        dia.push(u)
      } else if (uy.isMix(u.index)) {
        neo.push(u)
        rea.push(u)
      } else {
        rea.push(u)
      }
    }

    result[y] = {
      reaInfADI: rea,
      neoInfADI: neo,
      diaInfADI: dia,
      expADI: uy.list
    }
  }
  return result
})()

function bactADI (label, year) {
  return {
    label: label,
    subtitle: 'Bactériémies associées aux dispositifs invasifs',
    color: css.bactADI,
    sheets: buildSheets(imports.bactADI, year),
    type: moduleTypes.surveillance,
    needClosure: true
  }
}

function buildSurveillanceModule (label, id, year) {
  return {
    label: label,
    color: css[id],
    units: moduleUnits[year][id],
    sheets: buildSheets(imports[id], year),
    type: moduleTypes.surveillance,
    needClosure: true
  }
}

function reaInfADI (year) {
  return buildSurveillanceModule(
    'Réa Inf ADI AD/PED',
    'reaInfADI',
    year
  )
}

function diaInfADI (year) {
  return buildSurveillanceModule(
    'Dia Inf ADI',
    'diaInfADI',
    year
  )
}

function neoInfADI (year) {
  return buildSurveillanceModule(
    'Néo Inf ADI',
    'neoInfADI',
    year
  )
}

function expADI (year) {
  return buildSurveillanceModule(
    'Exp ADI',
    'expADI',
    year
  )
}

function observa4 (year) {
  return {
    label: 'OBSERVA4',
    color: css.observa4,
    type: moduleTypes.observation,
    format: {
      obsManagment: obsManagmentFormatter
    },
    sheets: buildSheets(imports.observa4, year),
    removeEmptyColumns: true,
    needClosure: true
  }
}

function spy4 (year) {
  return {
    label: 'SPY4',
    color: css.spy4,
    type: moduleTypes.observation,
    sheets: buildSheets(imports.spy4, year),
    removeEmptyColumns: true,
    needClosure: true
  }
}

function badiCause (year) {
  return {
    label: 'BADICAUSE',
    color: css.badiCause,
    type: moduleTypes.causeAnalysis,
    sheets: buildSheets(imports.badicause, year),
    needClosure: true
  }
}

function reaSink () {
  return {
    label: 'RÉA Sink',
    color: css.reaSink,
    type: moduleTypes.observation,
    needClosure: false,
    units: {
      component: 'select-unit',
      config: (parent, modules) => {
        const reaModules = ['reaInfADI', 'neoInfADI', 'expADI']
        const result = []
        reaModules.forEach(
          r => {
            const m = modules[r]
            if (m != null) {
              m.ufs.forEach(
                uf => {
                  if (go.units.isAllowedForReaSink(uf.ufType)) {
                    const type = units['2020'].infADI.find(u => u.index === uf.ufType)
                    result.push(
                      {
                        label: `${uf.name} (${type.code})`,
                        type: type,
                        value: uf
                      }
                    )
                  }
                }
              )
            }
          }
        )
        const label = (t, l) => `<span class="label label-${t}">${l}</span>`
        return {
          type: 'reaSink',
          title: `UF ${parent.label}`,
          empty: `Veuillez sélectionner un service parmi les inscrits
à ${label('expADI', expADI('2020').label)},
${label('reaInfADI', reaInfADI('2020').label)} et
${label('neoInfADI', neoInfADI('2020').label)}
en utilisant le formulaire ci-dessous.`,
          fieldLabel: 'UF (inscrite à SPIADI 2020)',
          list: result
        }
      }
    }
  }
}

function reaExplaur (year) {
  const filter = (e) => {
    if (year === '2021' || year === '2022') {
      return go.units.isAllowedForReaExplaur2021(e.index)
    }
    return go.units.isAllowedForReaExplaur(e.index)
  }

  return {
    label: 'RÉA expl AUR',
    color: css.reaExplaur,
    type: moduleTypes.observation,
    sheets: {},
    needClosure: false,
    units: units[year].list.filter(filter)
  }
}

function topCvp () {
  const excludedList = [
    64, 66, 71, 49
  ]
  const filter = (e) => {
    return excludedList.indexOf(e.index) === -1
  }

  return {
    label: 'Top CVP',
    color: css.topCvp,
    type: moduleTypes.research,
    units: units['2025'].list.filter(filter),
    sheets: {},
    needClosure: false
  }
}

export default {
  types: moduleTypes,

  '2019': {
    results: resultsModule,
    bactADI: bactADI('Bact ADI', '2019'),
    reaBactADI: {
      label: 'Réa Bact ADI',
      units: units['2019'].infADI,
      color: css.reaBactADI,
      sheets: buildSheets(imports.reaBactADI, '2019'),
      type: moduleTypes.surveillance
    },
    reaInfADI: reaInfADI('2019'),
    diaInfADI: diaInfADI('2019'),
    neoInfADI: neoInfADI('2019')
  },

  '2020': {
    results: resultsModule,
    bactADI: bactADI('Bact ADI+', '2020'),
    expADI: expADI('2020'),
    reaInfADI: reaInfADI('2020'),
    diaInfADI: diaInfADI('2020'),
    neoInfADI: neoInfADI('2020'),
    observa4: observa4('2020'),
    reaSink: reaSink()
  },

  '2021': {
    results: resultsModule,
    bactADI: bactADI('Bact ADI+', '2021'),
    expADI: expADI('2021'),
    reaInfADI: reaInfADI('2021'),
    diaInfADI: diaInfADI('2021'),
    neoInfADI: neoInfADI('2021'),
    observa4: observa4('2021'),
    reaExplaur: reaExplaur('2021')
  },

  '2022': {
    results: resultsModule,
    bactADI: bactADI('Bact ADI+', '2022'),
    expADI: expADI('2022'),
    reaInfADI: reaInfADI('2022'),
    diaInfADI: diaInfADI('2022'),
    neoInfADI: neoInfADI('2022'),
    observa4: observa4('2022'),
    reaExplaur: reaExplaur('2022')
  },

  '2023': {
    results: resultsModule,
    bactADI: bactADI('Bact ADI+', '2023'),
    expADI: expADI('2023'),
    reaInfADI: reaInfADI('2023'),
    diaInfADI: diaInfADI('2023'),
    neoInfADI: neoInfADI('2023'),
    observa4: observa4('2023'),
    reaExplaur: reaExplaur('2023')
  },

  '2024': {
    results: resultsModule,
    bactADI: bactADI('Bact ADI+', '2024'),
    expADI: expADI('2024'),
    reaInfADI: reaInfADI('2024'),
    diaInfADI: diaInfADI('2024'),
    neoInfADI: neoInfADI('2024'),
    observa4: observa4('2024'),
    reaExplaur: reaExplaur('2024')
  },

  '2025': {
    results: resultsModule,
    bactADI: bactADI('Bact ADI+', '2025'),
    expADI: expADI('2025'),
    reaInfADI: reaInfADI('2025'),
    diaInfADI: diaInfADI('2025'),
    neoInfADI: neoInfADI('2025'),
    observa4: observa4('2025'),
    reaExplaur: reaExplaur('2025'),
    topCvp: topCvp()
  },

  '2026': {
    results: resultsModule,
    bactADI: bactADI('Bact ADI+', '2026'),
    expADI: expADI('2026'),
    reaInfADI: reaInfADI('2026'),
    diaInfADI: diaInfADI('2026'),
    neoInfADI: neoInfADI('2026'),
    observa4: observa4('2026'),
    reaExplaur: reaExplaur('2026'),
    badiCause: badiCause('2026'),
    spy4: spy4('2026')
  },

  get: function (y, f) {
    if (y == null) {
      return {}
    }

    if (f == null) {
      return this[y]
    }

    const result = {}
    Object.keys(this[y]).forEach(
      k => {
        if (f(this[y][k])) {
          result[k] = this[y][k]
        }
      }
    )
    return result
  }
}
